import styled from 'styled-components';

export const CartItemOptionDetailsContainer = styled.div<{ isDeviceSmall: boolean }>`
  width: ${({ isDeviceSmall }) => (isDeviceSmall ? '100%' : '76%')};
  padding-top: 20px;
  align-self: flex-end;
  margin-left: ${({ isDeviceSmall }) => (isDeviceSmall ? '25px' : 'auto')};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
`;

export const ProductName = styled.div`
  margin-right: auto;
  font-family: 'Crimson Text';
`;

export const Includes = styled.p`
  color: #6c6c6c;
  font-family: 'Crimson Text';
  line-height: 150%;
  font-size: 14px;
`;

export const AddOnsContainer = styled.div`
  padding-left: 16px;
  border-left: 2px solid #efefef;
  gap: 16px;
`;

export const AddOnsTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  margin-bottom: 8px;
`;

export const AddOnRow = styled.div`
  margin-bottom: 10px;
`;

export const AddOnHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const AddOnText = styled.span`
  line-height: 150%;
  font-size: 14px;
  font-family: 'Crimson Text';
`;

export const OptionName = styled.span`
  white-space: pre;
`;

export const DependentOption = styled.p`
  color: #6c6c6c;
  line-height: 1rem;
  font-size: 0.85rem;
  font-family: 'Crimson Text';
`;
